export const gestureTypes = {
    static: 'static',
    staticRevert: 'staticRevert',
}

export const gesturesKeys = {
    raiseHand: 'raiseHand',
    thumbsUp: 'thumbsUp',
    confused: 'confused',
    party: 'party',
}

const GESTURE_ASSET_BASE_PATH = '/assets/revamp/gestures'
const MOBILE_ASSET_BASE = '/img/tiles/student/gestures'

export const gestureIds = {
    raised_hand_with_fingers_splayed: 'raised_hand_with_fingers_splayed',
    thumbsup: 'thumbsup',
    thinking_face: 'thinking_face',
    tada: 'tada',
}

export const gesturesData = [
    {
        id: gestureIds.raised_hand_with_fingers_splayed,
        gestureKey: gesturesKeys.raiseHand,
        assetPath: `${GESTURE_ASSET_BASE_PATH}/raise-hand.json`,
        autoRevert: false,
        available: ['student'],
    },
    {
        id: gestureIds.thumbsup,
        gestureKey: gesturesKeys.thumbsUp,
        assetPath: `${GESTURE_ASSET_BASE_PATH}/thumbs-up.json`,
        autoRevert: true,
        available: ['teacher', 'student'],
        mobileAssetPath: `${MOBILE_ASSET_BASE}/thumbsup.svg`,
    },
    {
        id: gestureIds.thinking_face,
        gestureKey: gesturesKeys.confused,
        assetPath: `${GESTURE_ASSET_BASE_PATH}/confused.json`,
        autoRevert: true,
        available: ['teacher', 'student'],
        // TODO: Do we have an svg for confused mobile icon ??
        mobileAssetPath: `${MOBILE_ASSET_BASE}/thumbsdown.svg`,
    },
    {
        id: gestureIds.tada,
        gestureKey: gesturesKeys.party,
        assetPath: `${GESTURE_ASSET_BASE_PATH}/party.json`,
        autoRevert: true,
        available: ['teacher', 'student'],
        mobileAssetPath: `${MOBILE_ASSET_BASE}/dance.svg`,
    },
]

// TODO: Remove the below objects once the new gestures for mobile come into full force
export const gesturesMap = {
    raiseHand: 'raiseHand',
    thumbsUp: 'thumbsUp',
    thumbsDown: 'thumbsDown',
    dance: 'dance',
}

const BASE = '/img/tiles/student/gestures'
export const gestures = [
    {
        src: `${BASE}/thumbsup.svg`,
        alt: gesturesMap.thumbsUp,
        key: gesturesMap.thumbsUp,
    },
    {
        src: `${BASE}/thumbsdown.svg`,
        alt: gesturesMap.thumbsDown,
        key: gesturesMap.thumbsDown,
    },
    {
        src: `${BASE}/dance.svg`,
        alt: gesturesMap.dance,
        key: gesturesMap.dance,
    },
]
